'use strict';

import ErrorResponse   from './ErrorResponse';
import {requestUrl, requestHeaders, requestOptions} from '@/store/graphQLClient.js'

export default class GQ 
{
    static async query(queries) {

        let _queries   = [];     
        let _variables = {};   
        for( let index in queries ) {

            if( ! queries.hasOwnProperty(index) ) {
                continue;
            } 

            let alias = 'query_' + index;
            let query = queries[index];
            _queries.push(alias + ': ' + query.gql());
            _variables = Object.assign(_variables, query.variables());
        }

        let options = Object.assign(
            {
                body: JSON.stringify({
                    query : '{' + _queries.join(' ') + '}',
                    variables : _variables
                }),
                headers: requestHeaders
            }, 
            requestOptions
        );

        return fetch(requestUrl, options)
            .then(function(response) {              

                if (response.headers.get('Content-Type') !== 'application/json') {
                    return response.blob();
                }

                return response.json();
            })
            .then(function(response){

                let result = {};

                if( response.hasOwnProperty('data') ) {

                    let data = response.data;

                    for ( let index in queries ) {

                        if( ! queries.hasOwnProperty(index) ) {
                            continue;
                        } 

                        let query = queries[index];
                        let alias = 'query_' + index;

                        let rawConnection = {};
                        if( data.hasOwnProperty(alias) ) {
                            rawConnection = data[alias];
                        }

                        result[index] = query.parseResponse(rawConnection);                        
                    }
                }

                if( response.hasOwnProperty('errors') ) {

                    let errors = [];

                    response.errors.forEach(function(error){
                        errors.push(error)
                    });

                    throw new ErrorResponse('Api Error', errors, result);
                }

                return result;
            });
    }
}


// WEBPACK FOOTER //
// ./src/graphql/GQ.js